module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center",
      "position": "relative"
    }
  }, [_vm._v("\n    MongoDB Explorer\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Collections")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--secondary",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "disabled": _vm.collectionsLoading,
      "title": "Refresh collections"
    },
    on: {
      "click": _vm.loadCollections
    }
  }, [_vm._v("\n        Refresh\n      ")])]), _vm._v(" "), (_vm.collectionsLoading) ? _c('div', {
    staticClass: "msg-center"
  }, [_c('p', [_vm._v("Loading collections...")])]) : _vm._e(), _vm._v(" "), (_vm.collectionsError) ? _c('div', {
    staticClass: "msg-center msg-error"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.collectionsError))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": _vm.loadCollections
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.collectionsLoading && !_vm.collectionsError && _vm.collections.length) ? _c('div', {
    staticClass: "collections-grid"
  }, _vm._l((_vm.collections), function(col) {
    return _c('button', {
      key: col,
      staticClass: "collection-chip",
      class: {
        'collection-chip--active': _vm.selectedCollection === col
      },
      on: {
        "click": function($event) {
          return _vm.selectCollection(col)
        }
      }
    }, [_vm._v("\n        " + _vm._s(col) + "\n      ")])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.selectedCollection) ? _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Lookup in "), _c('span', {
    staticClass: "collection-name"
  }, [_vm._v(_vm._s(_vm.selectedCollection))])])]), _vm._v(" "), _c('div', {
    staticClass: "lookup-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentId),
      expression: "documentId"
    }],
    staticClass: "doc-id-input",
    attrs: {
      "id": "mongo-doc-id-input",
      "type": "text",
      "placeholder": "Enter document ID (e.g. race ID or run ID)"
    },
    domProps: {
      "value": (_vm.documentId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchDocument.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "mongo-fetch-btn",
      "disabled": !_vm.documentId || _vm.documentId.trim() === '' || _vm.fetchLoading
    },
    on: {
      "click": _vm.fetchDocument
    }
  }, [_vm._v("\n        " + _vm._s(_vm.fetchLoading ? 'Fetching...' : 'Fetch') + "\n      ")])]), _vm._v(" "), (_vm.fetchError) ? _c('div', {
    staticClass: "msg-center msg-error",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.fetchError))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fetchAttempted) ? _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Result")]), _vm._v(" "), (_vm.document) ? _c('span', {
    staticClass: "last-updated"
  }, [_vm._v("\n        " + _vm._s(Object.keys(_vm.document).length) + " top-level keys\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.fetchLoading) ? _c('div', {
    staticClass: "msg-center"
  }, [_c('p', [_vm._v("Loading document...")])]) : _vm._e(), _vm._v(" "), (!_vm.fetchLoading && !_vm.document && !_vm.fetchError) ? _c('div', {
    staticClass: "msg-center",
    staticStyle: {
      "color": "#666"
    }
  }, [_c('p', [_vm._v("No document found for ID "), _c('strong', [_vm._v(_vm._s(_vm.lastQueriedId))]), _vm._v(" in "), _c('strong', [_vm._v(_vm._s(_vm.selectedCollection))]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (!_vm.fetchLoading && _vm.document) ? _c('div', [_c('div', {
    staticClass: "stats-grid",
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, _vm._l((_vm.topLevelKeys), function(key) {
    return _c('div', {
      key: key,
      staticClass: "stat-card"
    }, [_c('div', {
      staticClass: "stat-label"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "stat-value-small"
    }, [_vm._v(_vm._s(_vm.formatValue(_vm.document[key])))])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "btn btn--secondary",
    on: {
      "click": function($event) {
        _vm.showFullJson = !_vm.showFullJson
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showFullJson ? 'Hide Full JSON' : 'Show Full JSON') + "\n        ")])]), _vm._v(" "), (_vm.showFullJson) ? _c('div', {
    staticClass: "json-viewer"
  }, [_c('pre', [_vm._v(_vm._s(_vm.prettyJson))])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2192591a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/MongoExplorer.vue
// module id = 1641
// module chunks = 2